

export const vCustom = async (
  rule,
  val,
) => {
  if (!rule.validator) return null;

  try {
    await rule.validator(null, val);
    return null;
  } catch (e) {
    return e;
  }
};
